import { LinearProgress } from "@mui/material";
import { PackageDetails } from "./PackageDetails";
import { usePublicPackage } from "../../publicPackages/usePublicPackage";
import type { UserRole } from "../../auth/auth";

export function PublicPackagePage({ role }: { role: UserRole | null }) {
  const { data, isLoading } = usePublicPackage();
  const maxWidth = 900;
  return (
    <>
      {isLoading && <LinearProgress />}
      {data && <PackageDetails value={data} maxWidth={maxWidth} role={role} onBack={() => window.history.back()} />}
    </>
  );
}
